const angular = require('angular');

const { browseTileListComponentDefinition } = require('./browse-tile-list.component');
const { browseLeftPanelComponentDefinition } = require('./browse-left-panel.component');

angular.module('wowApp.shop')
    .component('wowBrowseTileList', browseTileListComponentDefinition)
    .component('wowBrowseLeftPanel', browseLeftPanelComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/browse/index.js